module.exports = __webpack_public_path__ + "static/media/early3.f2803d86.JPG";